import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import defenderImage from '../assets/images/defendamos.svg';
import inspiraLogo from '../assets/images/inspira_logo.png';
import SupportSection from '../components/layout/SupportSection';
import DonationButton from '../components/layout/DonateButton';
import OurWork from '../components/layout/OurWork';
import DonationAmountSelector from '../components/layout/DonationAmountSelector';
import ImpactSection from '../components/layout/ImpactSection';
import TestimonialsSection from '../components/layout/TestimonialsSection';
import TeamSection from '../components/layout/Team';
import { motion } from 'framer-motion';

export default function Home() {
    const location = useLocation();

    useEffect(() => {
        const scrollToId = localStorage.getItem('scrollToId');
        if (scrollToId) {
            const section = document.getElementById(scrollToId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
                localStorage.removeItem('scrollToId');
            }
        }
    }, [location]);

    return (
        <motion.div className="min-h-screen bg-white">
            <motion.section
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 70, velocity: 10 }}
                className="relative bg-white py-16 lg:pb-24"
            >
                <div className='container mx-auto px-4 text-center'>
                    <motion.img
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ type: 'spring', stiffness: 70 }}
                        src={inspiraLogo}
                        alt="Inspira Logo"
                        className="w-1/5 h-auto mx-auto"
                    />
                    <img
                        src={defenderImage}
                        alt="Defendamos"
                        className="lg:w-11/12 h-auto mx-auto"
                    />
                    <div className='block lg:hidden mt-6'>
                        <DonationButton />
                    </div>
                </div>
            </motion.section>

            <DonationAmountSelector id='donation-amounts' />
            <SupportSection id="support-section" />
            <OurWork id="our-work" />
            <ImpactSection />
            <TeamSection id="team-section" />
            <TestimonialsSection />
        </motion.div>
    );
}
